/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Model SaaS API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateDocumentSpecificRuleDto,
  DocumentAccessResponseDto,
  DocumentPublishedConsultResponseDto,
  DocumentSpecificRuleResponseDto,
  DocumentSubmitSummaryResponseDto,
  DocumentValidationDecisionBodyDto,
  DocumentValidationReviewResponseDto,
  UpdateDocumentSpecificRuleDto,
} from '.././model';

import { apiAxios } from '../../axios-instance';

export const documentControllerList = (signal?: AbortSignal) => {
  return apiAxios<void>({ url: `/api/v1/documents`, method: 'GET', signal });
};

export const getDocumentControllerListQueryKey = () => {
  return [`/api/v1/documents`] as const;
};

export const getDocumentControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof documentControllerList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof documentControllerList>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentControllerListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentControllerList>>> = ({ signal }) =>
    documentControllerList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof documentControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerList>>
>;
export type DocumentControllerListQueryError = unknown;

export function useDocumentControllerList<
  TData = Awaited<ReturnType<typeof documentControllerList>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerList>>,
          TError,
          Awaited<ReturnType<typeof documentControllerList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerList<
  TData = Awaited<ReturnType<typeof documentControllerList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerList>>,
          TError,
          Awaited<ReturnType<typeof documentControllerList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerList<
  TData = Awaited<ReturnType<typeof documentControllerList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDocumentControllerList<
  TData = Awaited<ReturnType<typeof documentControllerList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentControllerListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const documentControllerCreate = (signal?: AbortSignal) => {
  return apiAxios<void>({ url: `/api/v1/documents`, method: 'POST', signal });
};

export const getDocumentControllerCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentControllerCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentControllerCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['documentControllerCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentControllerCreate>>,
    void
  > = () => {
    return documentControllerCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerCreate>>
>;

export type DocumentControllerCreateMutationError = unknown;

export const useDocumentControllerCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentControllerCreate>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentControllerCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDocumentControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentControllerGetMyAccess = (id: string, signal?: AbortSignal) => {
  return apiAxios<DocumentAccessResponseDto>({
    url: `/api/v1/documents/${id}/access`,
    method: 'GET',
    signal,
  });
};

export const getDocumentControllerGetMyAccessQueryKey = (id?: string) => {
  return [`/api/v1/documents/${id}/access`] as const;
};

export const getDocumentControllerGetMyAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof documentControllerGetMyAccess>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetMyAccess>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentControllerGetMyAccessQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentControllerGetMyAccess>>> = ({
    signal,
  }) => documentControllerGetMyAccess(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof documentControllerGetMyAccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentControllerGetMyAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerGetMyAccess>>
>;
export type DocumentControllerGetMyAccessQueryError = unknown;

export function useDocumentControllerGetMyAccess<
  TData = Awaited<ReturnType<typeof documentControllerGetMyAccess>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetMyAccess>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerGetMyAccess>>,
          TError,
          Awaited<ReturnType<typeof documentControllerGetMyAccess>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerGetMyAccess<
  TData = Awaited<ReturnType<typeof documentControllerGetMyAccess>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetMyAccess>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerGetMyAccess>>,
          TError,
          Awaited<ReturnType<typeof documentControllerGetMyAccess>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerGetMyAccess<
  TData = Awaited<ReturnType<typeof documentControllerGetMyAccess>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetMyAccess>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDocumentControllerGetMyAccess<
  TData = Awaited<ReturnType<typeof documentControllerGetMyAccess>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetMyAccess>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentControllerGetMyAccessQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const documentControllerListSubmits = (id: string, signal?: AbortSignal) => {
  return apiAxios<DocumentSubmitSummaryResponseDto[]>({
    url: `/api/v1/documents/${id}/submits`,
    method: 'GET',
    signal,
  });
};

export const getDocumentControllerListSubmitsQueryKey = (id?: string) => {
  return [`/api/v1/documents/${id}/submits`] as const;
};

export const getDocumentControllerListSubmitsQueryOptions = <
  TData = Awaited<ReturnType<typeof documentControllerListSubmits>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerListSubmits>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentControllerListSubmitsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentControllerListSubmits>>> = ({
    signal,
  }) => documentControllerListSubmits(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof documentControllerListSubmits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentControllerListSubmitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerListSubmits>>
>;
export type DocumentControllerListSubmitsQueryError = unknown;

export function useDocumentControllerListSubmits<
  TData = Awaited<ReturnType<typeof documentControllerListSubmits>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerListSubmits>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerListSubmits>>,
          TError,
          Awaited<ReturnType<typeof documentControllerListSubmits>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerListSubmits<
  TData = Awaited<ReturnType<typeof documentControllerListSubmits>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerListSubmits>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerListSubmits>>,
          TError,
          Awaited<ReturnType<typeof documentControllerListSubmits>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerListSubmits<
  TData = Awaited<ReturnType<typeof documentControllerListSubmits>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerListSubmits>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDocumentControllerListSubmits<
  TData = Awaited<ReturnType<typeof documentControllerListSubmits>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerListSubmits>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentControllerListSubmitsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const documentControllerSubmit = (id: string, signal?: AbortSignal) => {
  return apiAxios<DocumentSubmitSummaryResponseDto>({
    url: `/api/v1/documents/${id}/submits`,
    method: 'POST',
    signal,
  });
};

export const getDocumentControllerSubmitMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentControllerSubmit>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentControllerSubmit>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['documentControllerSubmit'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentControllerSubmit>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return documentControllerSubmit(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentControllerSubmitMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerSubmit>>
>;

export type DocumentControllerSubmitMutationError = unknown;

export const useDocumentControllerSubmit = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentControllerSubmit>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentControllerSubmit>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDocumentControllerSubmitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentControllerPublish = (id: string, signal?: AbortSignal) => {
  return apiAxios<void>({ url: `/api/v1/documents/${id}/publish`, method: 'POST', signal });
};

export const getDocumentControllerPublishMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentControllerPublish>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentControllerPublish>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['documentControllerPublish'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentControllerPublish>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return documentControllerPublish(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentControllerPublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerPublish>>
>;

export type DocumentControllerPublishMutationError = unknown;

export const useDocumentControllerPublish = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentControllerPublish>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentControllerPublish>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDocumentControllerPublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentControllerGetValidationReview = (id: string, signal?: AbortSignal) => {
  return apiAxios<DocumentValidationReviewResponseDto>({
    url: `/api/v1/documents/${id}/validation-review`,
    method: 'GET',
    signal,
  });
};

export const getDocumentControllerGetValidationReviewQueryKey = (id?: string) => {
  return [`/api/v1/documents/${id}/validation-review`] as const;
};

export const getDocumentControllerGetValidationReviewQueryOptions = <
  TData = Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentControllerGetValidationReviewQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof documentControllerGetValidationReview>>
  > = ({ signal }) => documentControllerGetValidationReview(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentControllerGetValidationReviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerGetValidationReview>>
>;
export type DocumentControllerGetValidationReviewQueryError = unknown;

export function useDocumentControllerGetValidationReview<
  TData = Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
          TError,
          Awaited<ReturnType<typeof documentControllerGetValidationReview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerGetValidationReview<
  TData = Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
          TError,
          Awaited<ReturnType<typeof documentControllerGetValidationReview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerGetValidationReview<
  TData = Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDocumentControllerGetValidationReview<
  TData = Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetValidationReview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentControllerGetValidationReviewQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const documentControllerDecideValidation = (
  id: string,
  validationId: string,
  documentValidationDecisionBodyDto: DocumentValidationDecisionBodyDto,
) => {
  return apiAxios<DocumentValidationReviewResponseDto>({
    url: `/api/v1/documents/${id}/validations/${validationId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: documentValidationDecisionBodyDto,
  });
};

export const getDocumentControllerDecideValidationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentControllerDecideValidation>>,
    TError,
    { id: string; validationId: string; data: DocumentValidationDecisionBodyDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentControllerDecideValidation>>,
  TError,
  { id: string; validationId: string; data: DocumentValidationDecisionBodyDto },
  TContext
> => {
  const mutationKey = ['documentControllerDecideValidation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentControllerDecideValidation>>,
    { id: string; validationId: string; data: DocumentValidationDecisionBodyDto }
  > = (props) => {
    const { id, validationId, data } = props ?? {};

    return documentControllerDecideValidation(id, validationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentControllerDecideValidationMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerDecideValidation>>
>;
export type DocumentControllerDecideValidationMutationBody = DocumentValidationDecisionBodyDto;
export type DocumentControllerDecideValidationMutationError = unknown;

export const useDocumentControllerDecideValidation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentControllerDecideValidation>>,
      TError,
      { id: string; validationId: string; data: DocumentValidationDecisionBodyDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentControllerDecideValidation>>,
  TError,
  { id: string; validationId: string; data: DocumentValidationDecisionBodyDto },
  TContext
> => {
  const mutationOptions = getDocumentControllerDecideValidationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentControllerGetPublishedConsult = (id: string, signal?: AbortSignal) => {
  return apiAxios<DocumentPublishedConsultResponseDto>({
    url: `/api/v1/documents/${id}/published-consult`,
    method: 'GET',
    signal,
  });
};

export const getDocumentControllerGetPublishedConsultQueryKey = (id?: string) => {
  return [`/api/v1/documents/${id}/published-consult`] as const;
};

export const getDocumentControllerGetPublishedConsultQueryOptions = <
  TData = Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentControllerGetPublishedConsultQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>
  > = ({ signal }) => documentControllerGetPublishedConsult(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentControllerGetPublishedConsultQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>
>;
export type DocumentControllerGetPublishedConsultQueryError = unknown;

export function useDocumentControllerGetPublishedConsult<
  TData = Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
          TError,
          Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerGetPublishedConsult<
  TData = Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
          TError,
          Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerGetPublishedConsult<
  TData = Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDocumentControllerGetPublishedConsult<
  TData = Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentControllerGetPublishedConsult>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentControllerGetPublishedConsultQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const documentControllerGetById = (id: string, signal?: AbortSignal) => {
  return apiAxios<void>({ url: `/api/v1/documents/${id}`, method: 'GET', signal });
};

export const getDocumentControllerGetByIdQueryKey = (id?: string) => {
  return [`/api/v1/documents/${id}`] as const;
};

export const getDocumentControllerGetByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof documentControllerGetById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetById>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentControllerGetByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentControllerGetById>>> = ({
    signal,
  }) => documentControllerGetById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof documentControllerGetById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentControllerGetByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerGetById>>
>;
export type DocumentControllerGetByIdQueryError = unknown;

export function useDocumentControllerGetById<
  TData = Awaited<ReturnType<typeof documentControllerGetById>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerGetById>>,
          TError,
          Awaited<ReturnType<typeof documentControllerGetById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerGetById<
  TData = Awaited<ReturnType<typeof documentControllerGetById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentControllerGetById>>,
          TError,
          Awaited<ReturnType<typeof documentControllerGetById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentControllerGetById<
  TData = Awaited<ReturnType<typeof documentControllerGetById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDocumentControllerGetById<
  TData = Awaited<ReturnType<typeof documentControllerGetById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentControllerGetById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentControllerGetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const documentControllerUpdate = (id: string) => {
  return apiAxios<void>({ url: `/api/v1/documents/${id}`, method: 'PATCH' });
};

export const getDocumentControllerUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentControllerUpdate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentControllerUpdate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['documentControllerUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentControllerUpdate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return documentControllerUpdate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerUpdate>>
>;

export type DocumentControllerUpdateMutationError = unknown;

export const useDocumentControllerUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentControllerUpdate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentControllerUpdate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDocumentControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentControllerDelete = (id: string) => {
  return apiAxios<void>({ url: `/api/v1/documents/${id}`, method: 'DELETE' });
};

export const getDocumentControllerDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentControllerDelete>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentControllerDelete>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['documentControllerDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentControllerDelete>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return documentControllerDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentControllerDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentControllerDelete>>
>;

export type DocumentControllerDeleteMutationError = unknown;

export const useDocumentControllerDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentControllerDelete>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentControllerDelete>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDocumentControllerDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentValueControllerList = (documentId: string, signal?: AbortSignal) => {
  return apiAxios<void>({ url: `/api/v1/documents/${documentId}/values`, method: 'GET', signal });
};

export const getDocumentValueControllerListQueryKey = (documentId?: string) => {
  return [`/api/v1/documents/${documentId}/values`] as const;
};

export const getDocumentValueControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof documentValueControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentValueControllerList>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentValueControllerListQueryKey(documentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentValueControllerList>>> = ({
    signal,
  }) => documentValueControllerList(documentId, signal);

  return { queryKey, queryFn, enabled: !!documentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof documentValueControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentValueControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentValueControllerList>>
>;
export type DocumentValueControllerListQueryError = unknown;

export function useDocumentValueControllerList<
  TData = Awaited<ReturnType<typeof documentValueControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentValueControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentValueControllerList>>,
          TError,
          Awaited<ReturnType<typeof documentValueControllerList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentValueControllerList<
  TData = Awaited<ReturnType<typeof documentValueControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentValueControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentValueControllerList>>,
          TError,
          Awaited<ReturnType<typeof documentValueControllerList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentValueControllerList<
  TData = Awaited<ReturnType<typeof documentValueControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentValueControllerList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDocumentValueControllerList<
  TData = Awaited<ReturnType<typeof documentValueControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof documentValueControllerList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentValueControllerListQueryOptions(documentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const documentValueControllerCreate = (documentId: string, signal?: AbortSignal) => {
  return apiAxios<void>({ url: `/api/v1/documents/${documentId}/values`, method: 'POST', signal });
};

export const getDocumentValueControllerCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentValueControllerCreate>>,
    TError,
    { documentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentValueControllerCreate>>,
  TError,
  { documentId: string },
  TContext
> => {
  const mutationKey = ['documentValueControllerCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentValueControllerCreate>>,
    { documentId: string }
  > = (props) => {
    const { documentId } = props ?? {};

    return documentValueControllerCreate(documentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentValueControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentValueControllerCreate>>
>;

export type DocumentValueControllerCreateMutationError = unknown;

export const useDocumentValueControllerCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentValueControllerCreate>>,
      TError,
      { documentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentValueControllerCreate>>,
  TError,
  { documentId: string },
  TContext
> => {
  const mutationOptions = getDocumentValueControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentValueControllerUpdate = (documentId: string, valueId: string) => {
  return apiAxios<void>({
    url: `/api/v1/documents/${documentId}/values/${valueId}`,
    method: 'PATCH',
  });
};

export const getDocumentValueControllerUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentValueControllerUpdate>>,
    TError,
    { documentId: string; valueId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentValueControllerUpdate>>,
  TError,
  { documentId: string; valueId: string },
  TContext
> => {
  const mutationKey = ['documentValueControllerUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentValueControllerUpdate>>,
    { documentId: string; valueId: string }
  > = (props) => {
    const { documentId, valueId } = props ?? {};

    return documentValueControllerUpdate(documentId, valueId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentValueControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentValueControllerUpdate>>
>;

export type DocumentValueControllerUpdateMutationError = unknown;

export const useDocumentValueControllerUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentValueControllerUpdate>>,
      TError,
      { documentId: string; valueId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentValueControllerUpdate>>,
  TError,
  { documentId: string; valueId: string },
  TContext
> => {
  const mutationOptions = getDocumentValueControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentValueControllerDelete = (documentId: string, valueId: string) => {
  return apiAxios<void>({
    url: `/api/v1/documents/${documentId}/values/${valueId}`,
    method: 'DELETE',
  });
};

export const getDocumentValueControllerDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentValueControllerDelete>>,
    TError,
    { documentId: string; valueId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentValueControllerDelete>>,
  TError,
  { documentId: string; valueId: string },
  TContext
> => {
  const mutationKey = ['documentValueControllerDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentValueControllerDelete>>,
    { documentId: string; valueId: string }
  > = (props) => {
    const { documentId, valueId } = props ?? {};

    return documentValueControllerDelete(documentId, valueId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentValueControllerDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentValueControllerDelete>>
>;

export type DocumentValueControllerDeleteMutationError = unknown;

export const useDocumentValueControllerDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentValueControllerDelete>>,
      TError,
      { documentId: string; valueId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentValueControllerDelete>>,
  TError,
  { documentId: string; valueId: string },
  TContext
> => {
  const mutationOptions = getDocumentValueControllerDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentSpecificRulesControllerList = (documentId: string, signal?: AbortSignal) => {
  return apiAxios<DocumentSpecificRuleResponseDto[]>({
    url: `/api/v1/documents/${documentId}/specific-rules`,
    method: 'GET',
    signal,
  });
};

export const getDocumentSpecificRulesControllerListQueryKey = (documentId?: string) => {
  return [`/api/v1/documents/${documentId}/specific-rules`] as const;
};

export const getDocumentSpecificRulesControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDocumentSpecificRulesControllerListQueryKey(documentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentSpecificRulesControllerList>>> = ({
    signal,
  }) => documentSpecificRulesControllerList(documentId, signal);

  return { queryKey, queryFn, enabled: !!documentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentSpecificRulesControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentSpecificRulesControllerList>>
>;
export type DocumentSpecificRulesControllerListQueryError = unknown;

export function useDocumentSpecificRulesControllerList<
  TData = Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
          TError,
          Awaited<ReturnType<typeof documentSpecificRulesControllerList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentSpecificRulesControllerList<
  TData = Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
          TError,
          Awaited<ReturnType<typeof documentSpecificRulesControllerList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentSpecificRulesControllerList<
  TData = Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDocumentSpecificRulesControllerList<
  TData = Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
  TError = unknown,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof documentSpecificRulesControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentSpecificRulesControllerListQueryOptions(documentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const documentSpecificRulesControllerCreate = (
  documentId: string,
  createDocumentSpecificRuleDto: CreateDocumentSpecificRuleDto,
  signal?: AbortSignal,
) => {
  return apiAxios<DocumentSpecificRuleResponseDto>({
    url: `/api/v1/documents/${documentId}/specific-rules`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDocumentSpecificRuleDto,
    signal,
  });
};

export const getDocumentSpecificRulesControllerCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentSpecificRulesControllerCreate>>,
    TError,
    { documentId: string; data: CreateDocumentSpecificRuleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentSpecificRulesControllerCreate>>,
  TError,
  { documentId: string; data: CreateDocumentSpecificRuleDto },
  TContext
> => {
  const mutationKey = ['documentSpecificRulesControllerCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentSpecificRulesControllerCreate>>,
    { documentId: string; data: CreateDocumentSpecificRuleDto }
  > = (props) => {
    const { documentId, data } = props ?? {};

    return documentSpecificRulesControllerCreate(documentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentSpecificRulesControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentSpecificRulesControllerCreate>>
>;
export type DocumentSpecificRulesControllerCreateMutationBody = CreateDocumentSpecificRuleDto;
export type DocumentSpecificRulesControllerCreateMutationError = unknown;

export const useDocumentSpecificRulesControllerCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentSpecificRulesControllerCreate>>,
      TError,
      { documentId: string; data: CreateDocumentSpecificRuleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentSpecificRulesControllerCreate>>,
  TError,
  { documentId: string; data: CreateDocumentSpecificRuleDto },
  TContext
> => {
  const mutationOptions = getDocumentSpecificRulesControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentSpecificRulesControllerUpdate = (
  documentId: string,
  ruleId: string,
  updateDocumentSpecificRuleDto: UpdateDocumentSpecificRuleDto,
) => {
  return apiAxios<DocumentSpecificRuleResponseDto>({
    url: `/api/v1/documents/${documentId}/specific-rules/${ruleId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateDocumentSpecificRuleDto,
  });
};

export const getDocumentSpecificRulesControllerUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentSpecificRulesControllerUpdate>>,
    TError,
    { documentId: string; ruleId: string; data: UpdateDocumentSpecificRuleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentSpecificRulesControllerUpdate>>,
  TError,
  { documentId: string; ruleId: string; data: UpdateDocumentSpecificRuleDto },
  TContext
> => {
  const mutationKey = ['documentSpecificRulesControllerUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentSpecificRulesControllerUpdate>>,
    { documentId: string; ruleId: string; data: UpdateDocumentSpecificRuleDto }
  > = (props) => {
    const { documentId, ruleId, data } = props ?? {};

    return documentSpecificRulesControllerUpdate(documentId, ruleId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentSpecificRulesControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentSpecificRulesControllerUpdate>>
>;
export type DocumentSpecificRulesControllerUpdateMutationBody = UpdateDocumentSpecificRuleDto;
export type DocumentSpecificRulesControllerUpdateMutationError = unknown;

export const useDocumentSpecificRulesControllerUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentSpecificRulesControllerUpdate>>,
      TError,
      { documentId: string; ruleId: string; data: UpdateDocumentSpecificRuleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentSpecificRulesControllerUpdate>>,
  TError,
  { documentId: string; ruleId: string; data: UpdateDocumentSpecificRuleDto },
  TContext
> => {
  const mutationOptions = getDocumentSpecificRulesControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const documentSpecificRulesControllerRemove = (documentId: string, ruleId: string) => {
  return apiAxios<void>({
    url: `/api/v1/documents/${documentId}/specific-rules/${ruleId}`,
    method: 'DELETE',
  });
};

export const getDocumentSpecificRulesControllerRemoveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentSpecificRulesControllerRemove>>,
    TError,
    { documentId: string; ruleId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentSpecificRulesControllerRemove>>,
  TError,
  { documentId: string; ruleId: string },
  TContext
> => {
  const mutationKey = ['documentSpecificRulesControllerRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentSpecificRulesControllerRemove>>,
    { documentId: string; ruleId: string }
  > = (props) => {
    const { documentId, ruleId } = props ?? {};

    return documentSpecificRulesControllerRemove(documentId, ruleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentSpecificRulesControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentSpecificRulesControllerRemove>>
>;

export type DocumentSpecificRulesControllerRemoveMutationError = unknown;

export const useDocumentSpecificRulesControllerRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentSpecificRulesControllerRemove>>,
      TError,
      { documentId: string; ruleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof documentSpecificRulesControllerRemove>>,
  TError,
  { documentId: string; ruleId: string },
  TContext
> => {
  const mutationOptions = getDocumentSpecificRulesControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
